import InputField from "../../UI/Inputs/InputField";
import Button from "../../UI/Button";
// import { FacebookIcon, GoogleIcon } from "../../Icons";
import { SignPropsType } from "../../../pages/Sign/utils";
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import style from "../../../pages/Sign/index.module.css";
import { useTranslation } from "../../../hooks/useTranslation";
// import { useGoogleLogin } from "react-google-login";

const Signin = ({ register, setActivePage, isSubmitting, errors }: SignPropsType) => {
  const { locale } = useTranslation();
  return (
    <>
      <InputField
        label={locale("phone")}
        placeholder={locale("phone")}
        type="phone"
        extraProps={register("signin_phone", { required: true })}
        error={errors?.signin_phone ? locale("required_field") : ""}
      />
      <InputField
        label={locale("password")}
        placeholder={locale("password")}
        type="password"
        extraProps={register("signin_password", { required: true })}
        error={errors?.signin_password ? locale("required_field") : ""}
      />
      <div className={style.remember_me}>
        <InputField label={locale("remember_me")} type="checkbox" extraProps={register("signin_remember")} />
      </div>
      <div className={style.forget_link}>
        <button disabled={isSubmitting} type="button" onClick={() => setActivePage?.("forget")}>
          {locale("forgot_password")}
          {locale("questionMark")}
        </button>
      </div>
      <div className={style.form_ctas}>
        <Button disabled={isSubmitting} isLoading={isSubmitting} styleType="primary_black" buttonType="submit">
          {locale("signin")}
        </Button>
        {/* <FacebookLogin
          appId="157831269510392"
          callback={(data: any) => onSocialLoginHandler?.("facebook", data)}
          cookie={false}
          render={(renderProps: any) => ( */}
        {/* <Button
          disabled={isSubmitting}
          styleType="primary_black"
          buttonType="button"
          // onClick={renderProps.onClick}
        >
          <FacebookIcon width="20" height="20" color="#fff" />
          {translation[siteLang].signin_with} {translation[siteLang].facebook}
        </Button> */}
        {/* )}
        /> */}
        {/* <Button
          disabled={isSubmitting}
          styleType="primary_black"
          buttonType="button"
          onClick={googleSignin}
        >
          <GoogleIcon width="20" height="20" color="#fff" />
          {translation[siteLang].signin_with} {translation[siteLang].google}
        </Button> */}
      </div>
    </>
  );
};

export default Signin;
